var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var EngineCameraState_1;
import { State, Action, Selector, createSelector } from '@ngxs/store';
import { EngineCameraStateModel } from './engine.camera.state.model';
import { StoreCamera, ClearCamera, MoveCamera, ZoomCamera, PanCameraX, RotateCameraX, PanCameraY, RotateCameraY, SetCameraMode, SetZoomed, LockCamera, ResetCamera } from './engine.camera.actions';
import { CameraService } from '../../camera.service';
import { CameraMotionModel } from '../../models/camera-motion.model';
import { tap } from 'rxjs/operators';
const engineCameraStateDefaults = {
    storedCameras: {},
    cameraMotion: new CameraMotionModel(),
    panMode: 'rotate',
    zoomed: false,
    lockCamera: false
};
let EngineCameraState = EngineCameraState_1 = class EngineCameraState {
    constructor(cameraService) {
        this.cameraService = cameraService;
    }
    /**
     * Selectors
     */
    static getStoredCamera(id) {
        return createSelector([EngineCameraState_1], (state) => {
            return state.storedCameras[id] || null;
        });
    }
    static getCameraMotion(state) {
        return state.cameraMotion;
    }
    static getPanMode(state) {
        return state.panMode;
    }
    static getZoomed(state) {
        return state.zoomed;
    }
    static getLockCamera(state) {
        return state.lockCamera;
    }
    /**
     * Actions
     */
    storeCamera(context, action) {
        const camera = action.camera || this.cameraService.getCamera();
        const storedCameras = context.getState().storedCameras;
        storedCameras[action.id] = Object.assign({}, camera);
        context.patchState({
            storedCameras: Object.assign({}, storedCameras)
        });
    }
    clearCamera(context, action) {
        const storedCameras = context.getState().storedCameras;
        delete storedCameras[action.id];
        context.patchState({
            storedCameras: Object.assign({}, storedCameras)
        });
    }
    moveCamera(context, action) {
        context.patchState({
            cameraMotion: Object.assign({}, action.cameraMotion)
        });
    }
    resetCamera(context, action) {
        return this.cameraService.resetCamera().pipe(tap(() => {
            context.patchState({
                cameraMotion: new CameraMotionModel()
            });
        }));
    }
    zoomCamera(context, action) {
        const { cameraMotion } = context.getState();
        cameraMotion.zoom = action.value;
        context.patchState({
            cameraMotion: Object.assign({}, cameraMotion)
        });
    }
    panCameraX(context, action) {
        const { cameraMotion } = context.getState();
        cameraMotion.panX = action.value;
        context.patchState({
            cameraMotion: Object.assign({}, cameraMotion)
        });
    }
    panCameraY(context, action) {
        const { cameraMotion } = context.getState();
        cameraMotion.panY = action.value;
        context.patchState({
            cameraMotion: Object.assign({}, cameraMotion)
        });
    }
    rotateCameraX(context, action) {
        const { cameraMotion } = context.getState();
        // cameraMotion.rotateX = action.value;
        context.patchState({
            cameraMotion: Object.assign({}, cameraMotion, { rotateX: action.value })
        });
    }
    rotateCameraY(context, action) {
        const { cameraMotion } = context.getState();
        cameraMotion.rotateY = action.value;
        context.patchState({
            cameraMotion: Object.assign({}, cameraMotion)
        });
    }
    SetCameraMode(context, action) {
        context.patchState({
            panMode: action.mode
        });
    }
    setZoomed(context, action) {
        context.patchState({
            zoomed: action.zoomed
        });
    }
    lockCamera(context, action) {
        context.patchState({
            lockCamera: action.lock
        });
    }
};
__decorate([
    Action(StoreCamera),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, StoreCamera]),
    __metadata("design:returntype", void 0)
], EngineCameraState.prototype, "storeCamera", null);
__decorate([
    Action(ClearCamera),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ClearCamera]),
    __metadata("design:returntype", void 0)
], EngineCameraState.prototype, "clearCamera", null);
__decorate([
    Action(MoveCamera),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, MoveCamera]),
    __metadata("design:returntype", void 0)
], EngineCameraState.prototype, "moveCamera", null);
__decorate([
    Action(ResetCamera),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ResetCamera]),
    __metadata("design:returntype", void 0)
], EngineCameraState.prototype, "resetCamera", null);
__decorate([
    Action(ZoomCamera),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ZoomCamera]),
    __metadata("design:returntype", void 0)
], EngineCameraState.prototype, "zoomCamera", null);
__decorate([
    Action(PanCameraX),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, PanCameraX]),
    __metadata("design:returntype", void 0)
], EngineCameraState.prototype, "panCameraX", null);
__decorate([
    Action(PanCameraY),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, PanCameraY]),
    __metadata("design:returntype", void 0)
], EngineCameraState.prototype, "panCameraY", null);
__decorate([
    Action(RotateCameraX),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, RotateCameraX]),
    __metadata("design:returntype", void 0)
], EngineCameraState.prototype, "rotateCameraX", null);
__decorate([
    Action(RotateCameraY),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, RotateCameraY]),
    __metadata("design:returntype", void 0)
], EngineCameraState.prototype, "rotateCameraY", null);
__decorate([
    Action(SetCameraMode),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetCameraMode]),
    __metadata("design:returntype", void 0)
], EngineCameraState.prototype, "SetCameraMode", null);
__decorate([
    Action(SetZoomed),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetZoomed]),
    __metadata("design:returntype", void 0)
], EngineCameraState.prototype, "setZoomed", null);
__decorate([
    Action(LockCamera),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, LockCamera]),
    __metadata("design:returntype", void 0)
], EngineCameraState.prototype, "lockCamera", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [EngineCameraStateModel]),
    __metadata("design:returntype", void 0)
], EngineCameraState, "getCameraMotion", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [EngineCameraStateModel]),
    __metadata("design:returntype", void 0)
], EngineCameraState, "getPanMode", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [EngineCameraStateModel]),
    __metadata("design:returntype", void 0)
], EngineCameraState, "getZoomed", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [EngineCameraStateModel]),
    __metadata("design:returntype", void 0)
], EngineCameraState, "getLockCamera", null);
EngineCameraState = EngineCameraState_1 = __decorate([
    State({
        name: 'engineCamera',
        defaults: engineCameraStateDefaults
    }),
    __metadata("design:paramtypes", [CameraService])
], EngineCameraState);
export { EngineCameraState };
